module.exports = __webpack_public_path__ + "img/figuur3.20c6a3ec.svg";